import React, { useState, useEffect } from "react";
import { createClient } from "contentful";
import BlogCard from "../components/BlogCard";
import Footer from "../components/Footer";

const Home = () => {
  const [blogs, setBlogs] = useState([]);
  const client = createClient({
    space: process.env.REACT_APP_SPACE_ID,
    accessToken: process.env.REACT_APP_ACCESS_TOKEN,
  });
  useEffect(() => {
    const getAllEntries = async () => {
      try {
        await client.getEntries({ content_type: "blog" }).then((entries) => {
          console.log(entries);
          setBlogs(entries);
        });
      } catch (error) {
        console.log(error);
      }
    };
    getAllEntries();
  }, [client]);

  return (
    <div className="w-100">
      <div className="w-100  lg:max-w-6xl mx-auto px-4   flex items-center justify-center">
        <div className="text-center md:max-w-[700px] py-16">
          <h2 className="text-3xl  md:text-5xl font-bold text-gray-800">
            Get your learning journey and job hunting right.
          </h2>
          <p className="text-gray-600 leading-normal  mt-8 text-lg md:text-xl">
            The Junior Dev Blog is the top hub to get educational materials,
            inspiration and help in your the job hunting journey with effective
            strategies to land tech job.
          </p>
          <div className="flex justify-center gap-5 mt-5">
            <span className="flex gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z"
                />
              </svg>
              Articles
            </span>
          </div>
          <div></div>
        </div>
      </div>
      <div className="w-100 lg:max-w-6xl mx-auto  px-2">
        <h2 className="text-2xl md:text-3xl font-semibold md:font-bold text-center mb-10">
          {" "}
          <span>🔥</span> Popular this week
        </h2>
        <div className="w-100 md:max-w-[960px] md:mx-auto">
          {blogs?.items?.map((post) => (
            <BlogCard key={post.sys.id} post={post} />
          ))}
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Home;
